export interface Category {
  name: string;
  href: string;
  seq: string;
}

export const categories: Category[] = [
  { name: 'Shoes', href: 'https://kaspreadsheet.com/category-911-Shoes.html', seq: 'cat-01' },
  { name: 'Hoodies/Sweaters', href: 'https://kaspreadsheet.com/search-912/name/Shoes.html', seq: 'cat-02' },
  { name: 'T-Shirts', href: 'https://kaspreadsheet.com/search-913/name/Shoes.html', seq: 'cat-03' },
  { name: 'Jackets', href: 'https://kaspreadsheet.com/search-914/name/Shoes.html', seq: 'cat-04' },
  { name: 'Pants/Shorts', href: 'https://kaspreadsheet.com/search-915/name/Shoes.html', seq: 'cat-05' },
  { name: 'Headwear', href: 'https://kaspreadsheet.com/search-916/name/Shoes.html', seq: 'cat-06' },
  { name: 'Sets', href: 'https://kaspreadsheet.com/search-917/name/Shoes.html', seq: 'cat-07' },
  { name: 'Underwear/Underpants', href: 'https://kaspreadsheet.com/search-918/name/Shoes.html', seq: 'cat-08' },
  { name: 'Jersey', href: 'https://kaspreadsheet.com/search-919/name/Shoes.html', seq: 'cat-09' },
  { name: 'Accessories', href: 'https://kaspreadsheet.com/search-920/name/Shoes.html', seq: 'cat-10' },
  { name: 'Bags', href: 'https://kaspreadsheet.com/search-921/name/Shoes.html', seq: 'cat-11' },
  { name: 'Belts', href: 'https://kaspreadsheet.com/search-922/name/Shoes.html', seq: 'cat-12' },
  { name: 'Perfumes', href: 'https://kaspreadsheet.com/search-923/name/Shoes.html', seq: 'cat-13' },
  { name: 'Other Stuff', href: 'https://kaspreadsheet.com/search-924/name/Shoes.html', seq: 'cat-14' },
];

export const featuredCategories: Category[] = [
  categories[0],
  categories[1],
  categories[2],
  categories[3],
  categories[4],
];

export const testimonials = [
  {
    name: 'Marcus R.',
    role: 'Streetwear Collector',
    text: 'GTBuy sheet completely changed how I shop. I used to jump between 5 tabs comparing prices — now it is all in one structured view. Saved me at least $200 last month alone.',
    avatarSeq: 'avatar-01',
  },
  {
    name: 'Elena K.',
    role: 'Fashion Reseller',
    text: 'The spreadsheet comparison engine is a game-changer for my business. I can instantly spot which platform has the best margins on any product. Absolutely essential tool for resellers.',
    avatarSeq: 'avatar-02',
  },
  {
    name: 'Jordan T.',
    role: 'Sneaker Enthusiast',
    text: 'Finally a tool that gets it. The GTBuy spreadsheet shows me real-time price differences between Kakobuy and Superbuy. No more guessing which platform has the better deal on Jordans.',
    avatarSeq: 'avatar-03',
  },
  {
    name: 'Sofia M.',
    role: 'Budget Shopper',
    text: 'I am not a reseller, just someone who hates overpaying. GTBuy sheet makes comparison shopping effortless. The structured data approach is so much better than reading scattered reviews.',
    avatarSeq: 'avatar-04',
  },
  {
    name: 'Derek L.',
    role: 'Tech Buyer',
    text: 'Started using GTBuy for sneakers, now I use it for everything — electronics, accessories, even home goods. The spreadsheet engine scales across any product category I throw at it.',
    avatarSeq: 'avatar-05',
  },
];